const Features = () => {
  return <div>Here is features page</div>;
};

export default Features;
